import SlideManager from "./slide-manager";
import RenderManager from "../rendering/render-manager";
import CameraTweenTrack from "../camera/camera-tween-track";
import { KeyframeTweenTransform } from "../camera/camera-tweens/tween-transform";
import { Tween } from "../camera/camera-tweens/base-tween";
import getSlideNumber from "./get-slide-number";
import AssetLibrary from "../assets/asset-library";

const tweenCameraTo = (function () {
    function onStartTimeline() {
        Q3.controls.tweening = true;

        Q3.labels.live.setLocked(true);

        if (Q3.editMode) Q3.undoService.setLocked(true);
    }

    function onCompleteTimeline(position, target) {
        RenderManager.activeCamera.position.copy(position);

        Q3.controls.target.copy(target);
        Q3.controls.tweening = false;

        Q3.labels.live.clearLast();

        RenderManager.enqueRaycaster();

        Q3.labels.live.setLocked(false);

        if (Q3.editMode) Q3.undoService.setLocked(false);

        CameraTweenTrack.activeTimeline = null;
    }

    const tmpPosition = new THREE.Vector3(), tmpTarget = new THREE.Vector3();

    return function tweenCameraTo(timeline, tweenDuration, { position, target }) {
        const currentKeyframeTransform = new KeyframeTweenTransform({
            position: RenderManager.activeCamera.position,
            target: Q3.controls ? Q3.controls.target : new THREE.Vector3()
        });

        position = tmpPosition.fromArray(position);
        target = tmpTarget.fromArray(target);

        const desiredKeyframeTransform = new KeyframeTweenTransform({ position, target });
        const tweens = [new Tween(currentKeyframeTransform, desiredKeyframeTransform)];

        timeline.add(onStartTimeline, 0);

        tweens.forEach(tween => {
            const _tween = tween.keyframeBegin.tweenTo(tween.keyframeGoal, tweenDuration);
            timeline.add(_tween, 1e-5);
        });

        timeline.add(onCompleteTimeline.bind(undefined, position, target), 1e-5 + tweenDuration);
    }
})();


function tweenObjects(timeline, tweenDuration, objects) {

    Object
        .keys(objects)
        .forEach(uuid => {
            const data = objects[uuid];
            const object = AssetLibrary.objects[uuid];

            const dVisible = data.visible;
            const dPosition = new THREE.Vector3().fromArray(data.position);
            const dQuaternion = new THREE.Quaternion().fromArray(data.quaternion);
            const dScale = new THREE.Vector3().fromArray(data.scale);

            const oPosition = new THREE.Vector3().copy(object.position);
            const oQuaternion = new THREE.Quaternion().copy(object.quaternion);
            const oScale = new THREE.Vector3().copy(object.scale);

            const source = { lerp: 0 };

            timeline.add(new TweenMax(source, tweenDuration, {
                lerp: 1,
                onStart() {
                    if (!dVisible) object.visible = dVisible;
                },
                onUpdate() {
                    object.position.lerpVectors(oPosition, dPosition, source.lerp);
                    object.quaternion.copy(oQuaternion).slerp(dQuaternion, source.lerp);
                    object.scale.lerpVectors(oScale, dScale, source.lerp);
                },
                onCompleted() {
                    if (dVisible) object.visible = dVisible;
                }
            }), 1e-5);
        });
}

async function syncSlide({ camera, objects, slideUuid, tweenDuration }) {
    const slideNumber = getSlideNumber(Q3.data, slideUuid);

    if (SlideManager.activeSlide !== slideNumber)
        await SlideManager.setSlide(slideNumber, { noAnimation: true });

    const timeline = CameraTweenTrack.activeTimeline = new TimelineLite({ paused: true });

    CameraTweenTrack.killTweens();

    tweenDuration = Math.max(tweenDuration, 1e-5);

    tweenCameraTo(timeline, tweenDuration, camera);
    tweenObjects(timeline, tweenDuration, objects);

    timeline.play();
}

function getSlideSyncData(tweenDuration) {
    const slideUuid = SlideManager.currentSlide.uuid;
    const camera = {
        position: RenderManager.activeCamera.position.toArray(),
        target: Q3.controls.target.toArray()
    };

    const objects = Object
        .keys(Q3.data.assets.objects)
        .reduce((accum, uuid) => {
            const { position, quaternion, scale, visible } = AssetLibrary.objects[uuid];

            accum[uuid] = {
                position: position.toArray(),
                quaternion: quaternion.toArray(),
                scale: scale.toArray(),
                visible
            };

            return accum;
        }, {});

    return { slideUuid, tweenDuration, camera, objects };
}

export default syncSlide;
export { syncSlide, getSlideSyncData };